export class RegulatoryActivityModel {
  level?: string;
  sector?: string;
  territory?: string;
  authority?: string;
  dateScaleFrom?: string;
  dateScaleTo?: string;
  publishedFrom?: string;
  publishedTo?: string;
  dateScalePreset?: string;
  publishedPreset?: string;
  orderBy?: string;
  orderDirection?: 'ASC' | 'DESC';
  take?: number;
  skip?: number;
  regPlanId?: string;
  regulatorTitle?: string;
  authorFullName?: string;
  authorPosition?: string;
  createdAt?: string;
  title?: string;
  deadline?: string;
  approvalDate?: string;
  approvalRequisites?: string;
  viewCount?: number;

  constructor(item: any) {
    this.level = item.level;
    this.sector = item.sector;
    this.territory = item.territory;
    this.authority = item.authority;
    this.dateScaleFrom = item.dateScaleFrom;
    this.dateScaleTo = item.dateScaleTo;
    this.publishedFrom = item.publishedFrom;
    this.publishedTo = item.publishedTo;
    this.dateScalePreset = item.dateScalePreset;
    this.publishedPreset = item.publishedPreset;
    this.orderBy = item.orderBy;
    this.orderDirection = item.orderDirection;
    this.take = item.take;
    this.skip = item.skip;
    this.regPlanId = item.regPlanId;
    this.regulatorTitle = item.regulatorTitle;
    this.authorFullName = item.authorFullName;
    this.authorPosition = item.authorPosition;
    this.createdAt = item.createdAt;
    this.title = item.title;
    this.deadline = item.deadline;
    this.approvalDate = item.approvalDate;
    this.approvalRequisites = item.approvalRequisites;
    this.viewCount = item.viewCount;
  }

  static fromJson(item: any): RegulatoryActivityModel {
    return new RegulatoryActivityModel(item);
  }
}
